
import { PO_NUMBER_CHANGE, UPDATED_SUMMARY } from '../../GlobalStateContainer'

export const SubTotal = function (state = 0, action) {
  return state;
}

const emptySummary = { Total: 0, SubTotal: 0, ShippingTotal: 0,  TaxTotal: 0, Currency: 'USD', TotalRemaining: 0 }

export const Summary = function (state = emptySummary, action) {
  switch (action.type) {
    case UPDATED_SUMMARY:
      state = action.summary;
  }
  if (typeof state.TotalRemaining === 'undefined')
    state = Object.assign({}, state, { TotalRemaining: state.Total });

  return state;
}



export function PONumber(state = '', action) {
  switch (action.type) {
  case PO_NUMBER_CHANGE:
    return action.number;
  default:
    return state;
  }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Summary/summaryReducers.js